enum ContactType {
    Email,
    Share,
}

export default ContactType;
